import { ContentBlock } from "@/types";
import { createSecurityServiceContent } from "@/content/services/service-content-helpers";

export const content: ContentBlock[] = [
  ...createSecurityServiceContent({
    serviceName: "security guards",
    summary:
      "Security guard work depends on the site, the people flow and the risks that need managing. Ozy Wide Group scopes the required duties before recommending guard coverage, from customer-facing presence through to access checks, patrols, lockups and incident escalation.",
    suitedTo: [
      "commercial premises",
      "construction sites",
      "events",
      "retail centres",
      "residential properties",
      "after-hours sites",
    ],
    includes: [
      "static guards",
      "concierge-style security",
      "access checks",
      "incident reporting",
      "site lockup or unlock support",
    ],
    notes: [
      "hours of coverage",
      "site rules",
      "visitor flow",
      "emergency contacts",
      "incident escalation",
      "licence requirements",
    ],
    process: [
      "Clarify what the guard is expected to prevent, observe, control or report.",
      "Match guard duties to the site layout, access points and operating hours.",
      "Confirm reporting, escalation contacts and handover details before coverage begins.",
    ],
    faq: [
      "Guard coverage should be scoped around duties, not only headcount.",
      "Clear instructions help guards respond consistently to visitors, contractors, alarms and incidents.",
      "Security licence and site induction requirements should be confirmed before shifts begin.",
    ],
  }),
];
